<script>
import Base from "@/components/RequestDetails/RequestCalls.vue";

export default {
  name: "DefaultViewRequestCalls",
  extends: Base,
};
</script>

